<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showAdd='!project.archived'
      :loading='isLoading'
      @add='addNote'
    >
      <v-data-table
        dense
        :items='notes'
        :headers='headers'
        :items-per-page='-1'
        hide-default-footer
        @click:row='editNote'
      >
        <template v-slot:item.note_type_display='{ item }'>
          {{ getTypeDisplay(item) }}
        </template>
        <template v-slot:item.wo='{ item }'>
          <v-chip v-if='item.wo' label xSmall color='primary' @click='openWO(item.wo)'>Open WO</v-chip>
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      :loadingButtons='changingNote'
      :loading='changingNote'
      :disableButtons='!isFormValid || exists'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='3'>
            <v-select
              label='Year'
              :items='dates'
              :rules='[rules.required]'
              v-model='copyNote.note_year'
            ></v-select>
          </v-col>
          <v-col cols='9'>
            <v-select
              label='Type'
              :items='typeOptions'
              item-value='value'
              item-text='text'
              :rules='[rules.required]'
              v-model='copyNote.note_type'
            ></v-select>
          </v-col>
        </v-row>
        <v-textarea
          label='Note'
          outlined
          :rules='[rules.required]'
          v-model='copyNote.note'
        ></v-textarea>
        <div v-if='exists' style="color: red">A one time note for that year and/or type already exists.</div>
      </v-form>
      <template v-slot:dialog-actions>
        <v-btn v-if="'id' in copyNote" text small color='red' :loading='changingNote' @click="deleteNote">Delete</v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import irrigationsAPI from '@/modules/irrigation/api/irrigations'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'one-time-notes',
  mixins: [formRules],
  props: {
    project: {
      required: true
    },
    title: {
      default: 'One time SU notes',
      type: String
    },
    notes: {
      required: true
    },
    isSUNote: {
      required: true,
      type: Boolean 
    },
    isLoading: {
      required: true,
      type: Boolean 
    }
  },
  data: () => ({
    changingNote: false,
    icon: 'mdi-text-subject',
    iconColor: 'warning',
    dates: [],
    typeOptions: [
      { text: 'Invoicing note', value: 'I' },
      { text: 'Scheduling note', value: 'S' },
      { text: 'Field note', value: 'F' }
    ],
    copyNote: {},
    headers: [
      { text: 'Year', value: 'note_year', align: 'left', width: '80' },
      { text: 'Type', value: 'note_type_display' },
      { text: 'Note', value: 'note' },
      { text: 'WO', value: 'wo', align: 'right' },
    ],
    showDialog: false,
    isFormValid: false,
    projectCopy: {}
  }),
  computed: {
    exists () {
      if ('id' in this.copyNote) {
        return this.notes.find(a => a.note_year === this.copyNote.note_year && a.note_type === this.copyNote.note_type && a.id !== this.copyNote.id)
      }
      return this.notes.find(a => a.note_year === this.copyNote.note_year && a.note_type === this.copyNote.note_type) !== undefined
    }
  },
  mounted () {
    const d = new Date()
    for (let i = 0; i < 5; i++) {
      this.dates.push(parseInt(d.getFullYear()) + i)
    }
  },
  methods: {
    editNote (note) {
      if (note.note_year < new Date().getFullYear()) {
        return
      }
      this.copyNote = _.cloneDeep(note)
      this.showDialog = true
    },
    addNote () {
      this.showDialog = true
      this.copyNote = { is_su_note: this.isSUNote, project: this.project.id }
      setTimeout(() => {
        this.$refs.form.reset()
      }, 100)
    },
    async deleteNote () {
      this.changingNote = true
      await irrigationsAPI.deleteOneTimeNote(this.copyNote.id)
      this.notes = miscServices.removeObject(this.notes, this.copyNote)
      this.changingNote = false
      this.showDialog = false
    },
    async saveChanges () {
      this.changingNote = true
      if ('id' in this.copyNote) {
        const updatedNote = await irrigationsAPI.updateOneTimeNote(this.copyNote)
        this.notes = miscServices.replaceObject(this.notes, updatedNote)
      } else {
        const newNote = await irrigationsAPI.createOneTimeNote(this.copyNote)
        this.notes.push(newNote)
      }
      this.showDialog = false
      this.changingNote = false
      if (this.copyNote.note_type === 'S') {
        this.$emit('updateSpecial', this.project)
      }
    },
    getTypeDisplay (item) {
      if (item.note_type === 'F') { return 'Field' }
      if (item.note_type === 'I') { return 'Invoicing' }
      if (item.note_type === 'S') { return 'Scheduling' }
      return '?'
    },
    openWO (woID) {
      this.$router.push({ name: 'WOOverview', params: { id: woID } })
    }
  }
}
</script>
